<template>
  <v-menu offset-x min-width="180px">
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon color="#1876D2">
        <v-icon small color="#017d59"> mdi-cog </v-icon>
      </v-btn>
    </template>

    <v-card class="card__menu">
      <div class="card__header">
        <span>MENU DE AÇÕES</span>
      </div>

      <!-- v-if="this.resource.enabled === true" -->
      <div
        class="menu__actions"
        v-for="action in actions"
        :key="action.name"
      >
        <div
          class="action">
          <div class="indicator" />
          <span>
            {{ action.name }}
          </span>
        </div>
      </div>

      <slot />
    </v-card>
  </v-menu>
</template>

<script>
// import settingEncryption from "@/utils/addEncryption";

export default {
  name: "MenuGridComponent",

  props: {
    resource: {
      type: Object,
    },
    actions: {},
  },


created() {
  // console.log(this.actions);
  
},
  methods: {
    setAction() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.card__menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 10px;

  .card__header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px 0;

    span {
      font-weight: 600;
      font-size: 10px;
    }
  }

  .menu__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .action {
      display: flex;
      width: 100%;
      align-items: center;
      margin: 3px 0;
      padding: 10px 0 10px 10px;
      border-radius: 10px !important;
      background: $x-light-gray;

      .indicator {
        height: 20px;
        width: 4px;
        background: $gray;
        border-radius: 10px;

        margin: 0 8px 0 0;
      }

      span {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .action:hover {
      background: $light-blue;
      cursor: pointer;

      .indicator {
        background: $blue;
      }

      span {
        color: $blue;
      }
    }
  }
}
</style>
